import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "videoBg" }
const _hoisted_2 = {
  class: "videoDom",
  muted: "",
  autoplay: "true",
  loop: "true",
  preload: "auto",
  "x-webkit-airplay": "allow",
  playsinline: "true",
  "x5-playsinline": "true",
  "webkit-playsinline": "true",
  "x5-video-player-type": "h5",
  "x5-video-player-fullscreen": "true",
  "x5-video-orientation": "portrait"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "videoLine" }, null, -1)
const _hoisted_5 = { class: "pageTitle" }
const _hoisted_6 = { class: "pageCentent" }
const _hoisted_7 = { class: "activeType" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "iconBox" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_11 = { class: "howGet" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "fastGet" }
const _hoisted_14 = { class: "tableCentent box1" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "fastGet" }
const _hoisted_17 = { class: "flex content2" }
const _hoisted_18 = { class: "btn" }
const _hoisted_19 = { class: "whereGet howGet" }
const _hoisted_20 = { class: "picList" }
const _hoisted_21 = ["src"]
const _hoisted_22 = ["src"]

import invitationZh from "@/assets/images/invitationZh.jpg";
import personalZh from "@/assets/images/personalZh.jpg";
import accountZh from "@/assets/images/accountZh.jpg";

import invitationEn from "@/assets/images/invitationEn.jpg";
import personalEn from "@/assets/images/personalEn.jpg";
import accountEn from "@/assets/images/accountEn.jpg";

import invitationZhM from "@/assets/mobile-images/invitationZhM.jpg";
import personalZhM from "@/assets/mobile-images/personalZhM.jpg";
import accountZhM from "@/assets/mobile-images/accountZhM.jpg";

import invitationEnM from "@/assets/mobile-images/invitationEnM.jpg";
import personalEnM from "@/assets/mobile-images/personalEnM.jpg";
import accountEnM from "@/assets/mobile-images/accountEnM.jpg";

import pcBgMP4 from "@/assets/video/newuservideobg.mp4";
import h5BgMP4 from "@/assets/video/newuservideoH5.mp4";
import i18n from "@/lang";
import store from "@/store";
import { watch, computed, ref, onMounted } from "vue";
import { isGotoLogin } from "@/utils/index";
import router from "@/router";

export default /*#__PURE__*/_defineComponent({
  __name: 'NewUser',
  setup(__props) {

const $t = i18n.global.t;
const appLanguage: any = computed(() => store.getters.getAppLanguage);
const isMobile: any = computed(() => !!store.state.isMobile);
const login: any = computed(() => store.state.isLogin);
const videoUrl: any = computed(() => (isMobile.value ? h5BgMP4 : pcBgMP4));
const typeList = ref();
const imgList = ref();
watch(
  () => appLanguage.value,
  () => {
    if (appLanguage.value == "en") {
      if (!isMobile.value) {
        imgList.value = [
          { url: invitationEn },
          { url: personalEn },
          { url: accountEn },
        ];
      } else {
        imgList.value = [
          { url: invitationEnM },
          { url: personalEnM },
          { url: accountEnM },
        ];
      }

      typeList.value = [
        {
          title: $t("active_page.active_type_m.register_title"),
          centent: $t("active_page.active_type_m.register_centent"),
        },
        {
          title: $t("active_page.active_type_m.invitation_title"),
          centent: $t("active_page.active_type_m.invitation_centent"),
        },
        {
          title: $t("active_page.active_type_m.purchase_title"),
          centent: $t("active_page.active_type_m.purchase_centent"),
        },
      ];
    } else {
      if (!isMobile.value) {
        imgList.value = [
          { url: invitationZh },
          { url: personalZh },
          { url: accountZh },
        ];
      } else {
        imgList.value = [
          { url: invitationZhM },
          { url: personalZhM },
          { url: accountZhM },
        ];
      }
      typeList.value = [
        {
          title: $t("active_page.active_type.register_title"),
          centent: $t("active_page.active_type.register_centent"),
        },
        {
          title: $t("active_page.active_type.invitation_title"),
          centent: $t("active_page.active_type.invitation_centent"),
        },
        {
          title: $t("active_page.active_type.purchase_title"),
          centent: $t("active_page.active_type.purchase_centent"),
        },
      ];
    }
  },
  { deep: true, immediate: true }
);

onMounted(() => {
  if (!login.value) {
    router.push({
      path: "/",
    });
  }
});

const getFastList = () => {
  return [
    {
      name: $t("pointsMall.fastName[0]"),
      centent: "20" + " " + $t("pointsMall.fastSocre[0]"),
    },
    {
      name: $t("pointsMall.fastName[1]"),
      centent: "50" + " " + $t("pointsMall.fastSocre[1]"),
    },
    {
      name: $t("pointsMall.fastName[2]"),
      centent: "10" + " " + $t("pointsMall.fastSocre[2]"),
    },
    {
      name: $t("pointsMall.fastName[3]"),
      centent: "200" + " " + $t("pointsMall.fastSocre[3]"),
    },
  ];
};
const getregisterList = () => {
  return [
    {
      name: $t("pointsMall.registertName[0]"),
      centent: "30" + " " + $t("pointsMall.registerSocre"),
    },
    {
      name: $t("pointsMall.registertName[1]"),
      centent: "20" + " " + $t("pointsMall.registerSocre"),
    },
  ];
};
// 判断是否登录
const isLogin = (id: number) => {
  if (!isGotoLogin()) {
    if (id == 1 || id == 2) {
      router.push({
        path: "/userCenter/personal",
      });
    } else {
      if (!isMobile) {
        router.push({
          path: "/userCenter/account",
        });
      } else {
        router.push({
          path: "/userCenter/personal",
        });
      }
    }
  }
};

const fastLists = ref();
fastLists.value = getFastList();
const registerLists = ref();
registerLists.value = getregisterList();
watch(
  () => store.getters.getAppLanguage,
  () => {
    registerLists.value = getregisterList();
    fastLists.value = getFastList();
  },
  {
    deep: true,
    immediate: true,
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pageBox", _unref(isMobile) ? 'mWidth' : 'pcWidth'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("video", _hoisted_2, [
        _createElementVNode("source", {
          src: _unref(videoUrl),
          type: "video/mp4"
        }, null, 8, _hoisted_3)
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", {
      class: _normalizeClass(_unref(isMobile) ? 'pageBoxM' : 'pageBoxPc')
    }, [
      _createElementVNode("h1", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(_unref($t)("active_page.title_left")), 1),
        _createElementVNode("span", null, _toDisplayString(_unref($t)("active_page.title_right")), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.index
              }, [
                _hoisted_8,
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(item.title) + " ", 1),
                  _hoisted_9
                ]),
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(item.centent) + " ", 1),
                  _hoisted_10
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h3", null, _toDisplayString(_unref($t)("pointsMall.how")), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_unref($t)("active_page.how_get.before")) + " ", 1),
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isLogin(1)))
            }, _toDisplayString(_unref($t)("active_page.how_get.name")), 1),
            _createTextVNode(" " + _toDisplayString(_unref($t)("active_page.how_get.after")), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: imgList.value[0].url,
              alt: ""
            }, null, 8, _hoisted_12)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h3", null, _toDisplayString(_unref($t)("pointsMall.fast")) + "?", 1),
          _createElementVNode("ul", {
            class: _normalizeClass(["tableBoxPc", _unref(isMobile) ? 'tableBoxM' : ''])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fastLists.value, (item, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(item.name), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex", _unref(isMobile) ? 'contentM' : 'content'])
                  }, [
                    _createElementVNode("div", null, _toDisplayString(item.centent), 1)
                  ], 2)
                ])
              ]))
            }), 128))
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("h3", null, _toDisplayString(_unref($t)("pointsMall.register")) + "?", 1),
          _createElementVNode("ul", {
            class: _normalizeClass(["tableBoxPc", _unref(isMobile) ? 'tableBoxM' : ''])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(registerLists.value, (item, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", null, _toDisplayString(item.name), 1),
                  _createElementVNode("div", null, _toDisplayString(item.centent), 1)
                ])
              ]))
            }), 128))
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isLogin(2)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($t)("active_page.button")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("h3", null, _toDisplayString(_unref($t)("active_page.where_get.title")), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_unref($t)("active_page.where_get.before")) + " ", 1),
            _createElementVNode("span", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (isLogin(3)))
            }, _toDisplayString(_unref($t)("active_page.where_get.name")), 1),
            _createTextVNode(" " + _toDisplayString(_unref($t)("active_page.where_get.after")), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("img", {
              src: imgList.value[1].url,
              alt: ""
            }, null, 8, _hoisted_21),
            _createElementVNode("img", {
              src: imgList.value[2].url,
              alt: ""
            }, null, 8, _hoisted_22)
          ])
        ])
      ])
    ], 2)
  ], 2))
}
}

})